module.exports = __webpack_public_path__ + "img/bx-trash.6413a4ad.svg";